import { z } from 'zod';
import { OrderDirection } from '@/constants/orderDirection';

/**
 * OUT 一覧のクエリ Schema。IN `_list/-constants.SearchSchema` と同型方針。
 * - pageIndex / pageSize / sortColumn / sortOrder（IN と完全同型）
 * - dataType: PEOPLE / DEVICE（OUT 固有のフィルタ。未指定で全件）
 */
export const SearchSchema = z.object({
  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),
  dataType: z.enum(['PEOPLE', 'DEVICE']).optional(),
  sortColumn: z.string().optional(),
  sortOrder: z.nativeEnum(OrderDirection).optional()
});